import {
    LIST_SHARE_CERTIFICATES,
    LIST_SHARE_CERTIFICATES_SUCCESS,
    LIST_SHARE_CERTIFICATES_FAILURE,
    GET_SHARE_CERTIFICATE,
    GET_SHARE_CERTIFICATE_SUCCESS,
    GET_SHARE_CERTIFICATE_FAILURE,
    SET_SHARE_CERTIFICATE_LIEN,
    SET_SHARE_CERTIFICATE_LIEN_SUCCESS,
    SET_SHARE_CERTIFICATE_LIEN_FAILURE
} from '../../../actions/index.types';

const initialState = {
    list: { loading: false, rows: [], pagination: null, error: null },
    detail: { loading: false, data: null, error: null },
    lien: { loading: false, success: false, error: null }
};

const ShareCertificateReducer = (state = initialState, action) => {
    switch (action.type) {
        // List
        case LIST_SHARE_CERTIFICATES:
            return { ...state, list: { ...state.list, loading: true, error: null } };
        case LIST_SHARE_CERTIFICATES_SUCCESS:
            return {
                ...state,
                list: {
                    loading: false,
                    rows: action.data?.data || [],
                    pagination: action.data?.meta?.pagination || null,
                    error: null
                }
            };
        case LIST_SHARE_CERTIFICATES_FAILURE:
            return { ...state, list: { ...state.list, loading: false, error: action.data } };

        // Detail
        case GET_SHARE_CERTIFICATE:
            return { ...state, detail: { loading: true, data: null, error: null } };
        case GET_SHARE_CERTIFICATE_SUCCESS:
            return { ...state, detail: { loading: false, data: action.data, error: null } };
        case GET_SHARE_CERTIFICATE_FAILURE:
            return { ...state, detail: { loading: false, data: null, error: action.data } };

        // Lien
        case SET_SHARE_CERTIFICATE_LIEN:
            return { ...state, lien: { loading: true, success: false, error: null } };
        case SET_SHARE_CERTIFICATE_LIEN_SUCCESS:
            return { ...state, lien: { loading: false, success: true, error: null } };
        case SET_SHARE_CERTIFICATE_LIEN_FAILURE:
            return { ...state, lien: { loading: false, success: false, error: action.data } };

        default:
            return state;
    }
};

export default ShareCertificateReducer;
